import { useEffect, useState } from 'react';

import { OnboardBiometricLogin } from './OnboardBiometricLogin';
import { isRunningInApp } from '@/utilities/sizeUtils';

export function Onboarding() {
  const [open, setOpen] = useState<'bio' | undefined>(undefined);

  useEffect(() => {
    if (!isRunningInApp()) {
      // show in app only
      localStorage.setItem('biometriclogin', 'notsupported');
      return;
    }
    const biometric = localStorage.getItem('biometriclogin');
    if (biometric === null) setOpen('bio');
  }, []);

  async function closePopup() {
    setOpen(undefined);
  }

  if (open === 'bio') return <OnboardBiometricLogin closePopup={closePopup} />;
  return null;
}
